let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2YGYU"), load("cGtlr"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));